module.exports = __webpack_public_path__ + "static/media/tools-pen.f882f0a1.svg";